import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout/Layout';
// import comboCardShopRouterMap from '@/router/asyncRouterMap/combo-card-shop';

Vue.use(Router);

export const constantRouterMap = [
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/pages/auth/pages/login2'),
    hidden: true
  },
  {
    path: '/no-sale-open',
    component: () => import('@/views/errorPage/no-sale-open'),
    name: 'noSaleOpen',
    hidden: true
  },
  {
    path: '/hub',
    component: () => import("@/views/Hub"),
    name: "Hub",
    hidden: true
  },
  // 开发-管理后台菜单使用,已在左侧菜单隐藏
  {
    path: '/development',
    component: Layout,
    redirect: '/development/tool-manage/menu-manage',
    name: 'development',
    meta: {
      title: 'development',
      icon: 'page'
    },
    hidden: true,
    children: [
      {
        path: '/development/tool-manage',
        component: () => import('@/views/development/tool-manage/index'),
        redirect: '/development/tool-manage/menu-manage',
        name: 'toolManage',
        meta: { title: 'toolManage' },
        children: [
          {
            path: 'menu-manage',
            component: () => import('@/views/development/tool-manage/menuManage'),
            name: 'menuManage',
            meta: { title: 'menuManage' }
          }
        ]
      },
    ]
  },
]

export const asyncRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: {
      title: 'sencond',
      icon: 'home'
    },
    name: 'sencond',
    children: [{
      path: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      name: 'dashboard',
      meta: { title: 'sencond' }
    }]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'first',
    meta: {
      title: 'first',
      icon: 'home'
    },
    children: [
      {
        path: 'home',
        component: () => import('@/views/dashboard/home'),
        name: 'home',
        meta: { title: 'home' }
      },
      {
        path: 'loginLog',
        component: () => import('@/views/log/loginLog'),
        name: 'loginLog',
        meta: { title: 'loginLog' }
      },
      {
        path: 'loginLoga',
        component: () => import('@/views/log/loginLog'),
        name: 'loginLoga',
        meta: { title: 'loginLoga' }
      },
      {
        path: 'handle',
        component: () => import('@/views/log/handle'),
        name: 'handleLog',
        meta: { title: 'handleLog' }
      },
      {
        path: 'handlea',
        component: () => import('@/views/log/handle'),
        name: 'handleLoga',
        meta: { title: 'handleLoga' }
      },
      {
        path: 'compromote',
        component: () => import('@/views/log/comPromote'),
        name: 'compromote',
        meta: { title: 'compromote' }
      }
    ]
  },

  // 页面管理
  {
    path: '/',
    component: Layout,
    redirect: '/loginJ',
    name: 'page',
    meta: {
      title: 'page',
      icon: 'page'
    },
    children: [
      {
        path: 'loginJ', // 登录日志
        component: () => import('@/views/page/journal/loginJournal'),
        name: 'loginJournal',
        meta: { title: 'loginJournal' }
      },
      {
        path: 'operation', // 操作日志
        component: () => import('@/views/page/journal/operationJournal'),
        name: 'operationJournal',
        meta: { title: 'operationJournal' }
      },
      {
        path: 'floor-preload',
        component: () => import('@/pages/floor/floor-preload'),
        name: 'mobileFloorManageA',
        meta: { title: 'mobileFloorManageA' }
      },
      {
        path: 'floor-preload/:type/:id',
        component: () => import('@/pages/floor/floor-preload'),
        hidden: true
      },
      {
        path: 'floor',
        component: () => import('@/pages/floor/renovation/floor-renovation'),
        name: 'floor',
        hidden: true
      },
      {
        path: 'floor/:type/:id',
        component: () => import('@/pages/floor/renovation/floor-renovation'),
        name: 'floorWidthParams',
        hidden: true
      },
      {
        path: 'child',
        component: () => import('@/views/page/page-setting/childFloor'),
        name: 'childFloor',
        meta: { title: 'childFloor' }
      },
      {
        path: 'special',
        component: () => import('@/views/page/special/list'),
        name: 'specialList',
        meta: { title: 'specialList' }
      },
      {
        path: 'special-edit',
        component: () => import('@/views/page/special/edit'),
        name: 'specialEdit',
        meta: { title: 'specialEdit' },
        hidden: true
      },
      {
        path: 'focus',
        component: () => import('@/views/page/mobile-decoration/mobileFocusManage'),
        name: 'mobileFocusManage',
        meta: { title: 'mobileFocusManage' }
      },
      {
        path: 'poverty-alleviation',
        component: () => import('@/views/page/mobile-decoration/povertyAlleviation'),
        name: 'povertyAlleviationWap',
        meta: { title: 'povertyAlleviationWap' }
      },
      {
        path: '/page/page-setting',
        component: () => import('@/views/page/page-setting/index'),
        redirect: '/page/page-setting/pc-site-menu',
        name: 'pageSetting',
        meta: { title: 'pageSetting' },
        children: [
          {
            path: 'mobile-site-menu',
            component: () => import('@/views/page/page-setting/mobileSiteMenu'),
            name: 'mobileSiteMenu',
            meta: { title: 'mobileSiteMenu' }
          },
          {
            path: 'hot-keyword',
            component: () => import('@/views/page/page-setting/hotKeyword'),
            name: 'hotKeyword',
            meta: { title: 'hotKeyword' }
          }
        ]
      }
    ]
  },
  // 集市
  {
    path: '/markets',
    component: Layout,
    redirect: '/markets/market',
    name: 'markets',
    meta: {
      title: 'markets',
      icon: 'market'
    },
    children: [
      {
        path: 'market',
        component: () => import('@/views/page/pc-decoration/market'),
        name: 'market',
        meta: { title: 'market' }
      },
      {
        path: 'goods',
        component: () => import('@/views/page/pc-decoration/goods'),
        name: 'marketGoods',
        hidden: true,
        meta: { title: 'marketGoods' }
      },

      {
        path: 'shopMarket',
        component: () => import('@/views/page/pc-decoration/goods'),
        name: 'shopMarket',
        hidden: true,
        meta: { title: 'marketGoods' }
      },
      {
        path: 'publish',
        component: () => import('@/views/page/pc-decoration/privateGoodsPublish'),
        name: 'privateGoodsPublish',
        hidden: true,
        meta: { title: 'privateGoodsPublish' }
      },
      {
        path: 'good',
        component: () => import('@/views/page/pc-decoration/good'),
        name: 'marketGood',
        hidden: true,
        meta: { title: 'marketGood' }
      },
      {
        path: 'gooda',
        component: () => import('@/views/page/pc-decoration/good'),
        name: 'marketGooda',
        hidden: true,
        meta: { title: 'marketGooda' }
      },
      {
        path: 'goodb',
        component: () => import('@/views/page/pc-decoration/good'),
        name: 'marketGoodb',
        hidden: true,
        meta: { title: 'marketGoodb' }
      },
      {
        path: 'privateGoods/:nav/:type',
        component: () => import('@/views/page/pc-decoration/privateGoods'),
        name: 'privateGoods',
        hidden: true,
        meta: {
          title: 'privateGoods',
          activeNames: ['market']
        }
      },
      {
        path: 'good-edit',
        component: () => import('@/views/goods/goodsPublish'),
        name: 'goodEdit1',
        meta: {
          title: 'goodEdit',
          noCache: true
        },
        hidden: true
      },
    ]
  },
  // 商品管理（商家）
  {
    path: '/shop-goods',
    component: Layout,
    redirect: '/shop-goods/shop-goods-purchase',
    name: 'shopGoods',
    meta: {
      title: 'shopGoods',
      icon: 'goods'
    },
    children: [

      // 商品选购
      {
        path: 'shop-goods-purchase',
        component: () => import('@/views/shopGoods/shopGoodsPurchase'),
        name: 'shopGoodsPurchase',
        meta: { title: 'shopGoodsPurchase' }
      },
      // 购物车
      {
        path: 'shop-carts',
        component: () => import('@/views/shopGoods/shopCarts'),
        name: 'shopCarts',
        meta: { title: 'shopGoodsPurchase', activeNames: ['shopGoodsPurchase'] },
        hidden: true

      },
      // 店铺商品
      {
        path: 'shop-goods-list',
        component: () => import('@/views/shopGoods/shopGoodsList'),
        name: 'shopGoodsList',
        meta: { title: 'shopGoodsList' }
      },
      {
        path: `edit-gift-goods/:id?`,
        component: () => import(`@/views/shopGoods/editGiftGoods`),
        name: `editGiftGoods`,
        meta: {
          title: 'editGiftGoods',
          noCache: true,
          activeNames: ['shopGoodsList']
        },
        hidden: true
      },
      {
        path: 'goodsListzd',
        component: () => import('@/views/shopGoods/goodsListzd'),
        name: 'goodsListzd',
        meta: { title: 'goodsListzd' },
        hidden: true
      },
      // 集市精选
      {
        path: 'market',
        component: () => import('@/views/shopGoods/market'),
        name: 'market1',
        meta: { title: 'market1' }
      },
      {
        path: 'goods',
        component: () => import('@/views/shopGoods/goods'),
        name: 'shopGoodsa',
        hidden: true,
        meta: { title: 'shopGoodsa' }
      },
      {
        path: 'goods/:nav/:type',
        component: () => import('@/views/shopGoods/goods'),
        name: 'shopGoodsa',
        hidden: true,
        meta: { title: 'shopGoodsa', activeNames: ['market1'] }
      },
      {
        path: 'good/:from',
        component: () => import('@/views/page/pc-decoration/good'),
        name: 'marketGooda',
        hidden: true,
        meta: { title: 'marketGooda' }
      },
      // 智能运营
      {
        path: 'intel-operation',
        component: () => import('@/views/shopGoods/intelOperation'),
        name: 'intelOperation',
        meta: {
          title: 'intelOperation'
        }
      },
      {
        path: 'publish',
        component: () => import('@/views/page/pc-decoration/privateGoodsPublish'),
        name: 'privateGoodsPublish',
        hidden: true,
        meta: { title: 'privateGoodsPublish' }
      },
      {
        path: 'tag-add/:tag_id',
        component: () => import('@/views/goods/tagAdd'),
        name: 'shopTagAdd',
        meta: { title: 'shopTagAdd' },
        hidden: true
      },
      {
        path: 'shop-good-publish/:goodsid?/:isdraft?',
        component: () => import('@/views/shopGoods/shopGoodPublish'),
        name: 'shopGoodPublish',
        meta: {
          title: 'shopGoodPublish',
          noCache: true
        },
        hidden: true
      },
      // 商品改价记录
      {
        path: 'price-change-record',
        name: 'PriceChangeRecord',
        component: () => import('@/pages/goods/pages/PriceChangeRecord/PriceChangeRecord'),
        meta: { title: 'PriceChangeRecord' }
      },
    ]
  },

  // 2.0 之前的用户路由
  {
    path: '/users',
    component: Layout,
    name: 'users',
    redirect: '/users/user-list',
    meta: {
      title: 'users',
      icon: 'user'
    },
    children: [
      {
        path: 'user-list',
        component: () => import('@/views/users/userList'),
        name: 'userList',
        meta: { title: 'userList' }
      },
      {
        path: 'fzadmin',
        component: () => import('@/views/users/fzadmin'),
        name: 'fzadmin',
        meta: { title: 'fzadmin' }
      },
      {
        path: 'userschong',
        component: () => import('@/views/users/userschong'),
        name: 'userschong',
        meta: { title: 'userschong' }
      },
      {
        path: 'user-msg',
        component: () => import('@/views/users/usersMsg'),
        name: 'usersMsg',
        hidden: true,
        meta: {
          title: 'usersMsg',
          activeNames: ['userList'],
        }
      },
      {
        path: 'chongMsg',
        component: () => import('@/views/users/chongMsg'),
        name: 'chongMsg',
        hidden: true,
        meta: {
          title: 'chongMsg',
          activeNames: ['userschong']
        }
      }
    ]
  },

  // 订单管理
  {

    path: '/order',
    component: Layout,
    name: 'order',
    redirect: '/order/order-list',
    meta: {
      title: 'order',
      icon: 'order'
    },
    children: [
      // 供应商
      {
        path: 'union-order-list',
        component: () => import('@/views/order/unionOrdertList'),
        name: 'unionOrderList',
        meta: { title: 'unionOrderList' }
      },
      {
        path: 'union-refund-list',
        component: () => import('@/views/order/unionRefundList/'),
        name: 'unionRefundList',
        meta: { title: 'unionRefundList' },
      },
      // 导入订单
      {
        path: 'importOrder',
        component: () => import('@/views/order/orderList/importOrder'),
        name: 'importOrder',
        meta: { title: 'importOrder' },
      },

      // 导入订单列表
      {
        path: 'importOrderList',
        component: () => import('@/views/order/orderList/importOrderList'),
        name: 'importOrderList',
        meta: { title: 'importOrderList' },
      },

      // 现金商城-订单列表
      {
        path: 'order-list',
        component: () => import('@/views/order/orderList/orderList'),
        name: 'orderList',
        meta: { title: 'orderList' },
      },
      // 现金商城-维权订单
      {
        path: 'refund-list',
        component: () => import('@/views/order/refundList/refundList'),
        name: 'refundList',
        meta: { title: 'refundList' },
      },
      {
        path: 'serve-list',
        component: () => import('@/views/order/serverList'),
        name: 'serverList',
        meta: { title: 'serverList' }
      },
      {
        path: 'coupon-order-list',
        component: () => import('@/views/order/couponOrderList'),
        name: 'couponOrderList',
        meta: { title: 'couponOrderList' }
      },
      {
        path: 'supplement-list',
        name: 'supplementList',
        component: () => import('@/views/order/supplement/supplementList'),
        meta: { title: 'supplementList' }
      },
      // 确认支付
      {
        path: 'importOrderConfirm',
        component: () => import('@/views/order/orderList/importOrder'),
        name: 'importOrderConfirm',
        meta: { title: 'importOrder', activeNames: ['importOrderList'] },
        hidden: true
      },
      {
        path: 'supplement-detail/:sn',
        name: 'supplementDetail',
        component: () => import('@/views/order/supplement/supplementDetail'),
        meta: { title: 'supplementDetail', activeNames: ['supplementList'] },
        hidden: true
      },
      // 导入订单象形
      {
        path: 'importOrderDetail',
        component: () => import('@/views/order/orderList/importOrderDetail'),
        name: 'importOrderDetail',
        meta: { title: 'importOrderDetail', activeNames: ['importOrderList'] },
        hidden: true
      },
      {
        path: 'coupon-order-detail/:id',
        component: () => import('@/views/order/couponOrderDetail'),
        name: 'couponOrderDetail',
        meta: {
          title: 'couponOrderDetail',
          activeNames: ['couponOrderList'],
        },
        hidden: true
      },
      {
        path: 'refund-detail/:sn',
        component: () => import('@/views/order/refundList/refundDetail'),
        name: 'refundDetail',
        meta: {
          title: 'refundDetail',
          activeNames: ['refundList'],
        },
        hidden: true
      },
      // 现金商城订单详情
      {
        path: ':route/detail/:sn',
        component: () => import('@/views/order/orderList/orderDetail'),
        name: 'orderDetail',
        hidden: true,
        meta: {
          title: 'orderDetail',
          activeNames: ['orderList'],
        }
      },

      // 现金商城订单详情
      {
        path: ':route/exportOrderRecords',
        component: () => import('@/views/order/orderList/exportOrderRecords'),
        name: 'exportOrderRecords',
        hidden: true,
        meta: {
          title: 'exportOrderRecords',
          activeNames: ['orderList'],
        }
      },
      // 供应商订单详情
      {
        path: 'union-refund-detail/:sn',
        component: () => import('@/views/order/unionRefundDetail'),
        name: 'unionRefundDetail',
        meta: { title: 'unionRefundDetail', activeNames: ['unionRefundList'] },
        hidden: true,
      },
    ]
  },
  // 财务管理
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/overview',
    name: 'finance',
    meta: {
      title: 'finance',
      icon: 'finance'
    },
    children: [
      {
        path: 'overview',
        component: () => import('@/views/finance/overview'),
        name: 'overview',
        meta: { title: 'overview' }
      },
      {
        path: 'enterprise-overview',
        component: () => import('@/views/finance/enterpriseOverview'),
        name: 'enterpriseOverview',
        meta: { title: 'enterpriseOverview' }
      },
      {
        path: 'shop-overview',
        component: () => import('@/views/finance/shopOverview'),
        name: 'shopOverview',
        meta: { title: 'shopOverview' }
      },
      {
        path: 'rechargeRecords', // 充值记录
        component: () => import('@/views/finance/rechargeRecords'),
        name: 'rechargeRecords',
        meta: { title: 'rechargeRecords' }
      },

      {
        path: 'summary',
        component: () => import('@/views/finance/summary'),
        name: 'summary',
        meta: { title: 'summary' }
      },
      {
        path: 'finance-summary',
        component: () => import('@/views/finance/summary'),
        name: 'financeSummary',
        meta: { title: 'financeSummary' }
      },
      {
        path: 'detailed',
        component: () => import('@/views/finance/detailed'),
        name: 'detailed',
        meta: { title: 'detailed' }
      },
      {
        path: 'finance-detailed',
        component: () => import('@/views/finance/financeDetailed'),
        name: 'financeDetailed',
        meta: { title: 'financeDetailed' }
      },
      {
        path: 'deal-detailed', // 交易明细
        component: () => import('@/views/finance/dealDetailed'),
        name: 'dealDetailed',
        meta: { title: 'dealDetailed' }
      },
      {
        path: 'reconciliationInvoices', // 对账开票
        component: () => import('@/views/finance/reconciliationInvoices/list'),
        name: 'reconciliationInvoices',
        meta: { title: 'reconciliationInvoices' }
      },
      {
        path: 'reconciliationInvoices/detail', // 对账开票
        component: () => import('@/views/finance/reconciliationInvoices/detail'),
        name: 'reconciliationInvoicesDetail',
        hidden: true,
        meta: { title: 'reconciliationInvoicesDetail', activeNames: ['reconciliationInvoices'], }
      },
      {
        path: 'cancel-after-verification',
        component: () => import('@/views/finance/writeOffOpenCard'),
        name: 'writeOffOpenCard',
        meta: { title: 'writeOffOpenCard' }
      },
      {
        path: 'cancel-after-verification-detailed',
        component: () => import('@/views/finance/writeOffOpenCardDetailed'),
        name: 'writeOffOpenCardDetailed',
        meta: {
          title: 'writeOffOpenCardDetailed',
          activeNames: ['writeOffOpenCard'],
        },
        hidden: true
      },
      {
        path: 'site-finance',
        component: () => import('@/views/finance/siteFinance'),
        name: 'siteFinance',
        meta: { title: 'siteFinance' }
      },
      {
        path: 'account',
        component: () => import('@/views/finance/account'),
        name: 'financeAccount',
        meta: { title: 'financeAccount' }
      },
      {
        path: 'accountg',
        component: () => import('@/views/finance/account'),
        name: 'financeAccountg',
        meta: { title: 'financeAccountg' }
      },
      {
        path: 'accounta',
        component: () => import('@/views/finance/account'),
        name: 'financeAccounta',
        meta: { title: 'financeAccounta' }
      },
      {
        path: 'money',
        component: () => import('@/views/finance/money'),
        name: 'guaranteeMoney',
        meta: { title: 'guaranteeMoney' }
      },
      {
        path: 'Invoicereview',
        component: () => import('@/views/finance/Invoicereview2'),
        name: 'Invoicereview',
        meta: { title: 'Invoicereview' }
      },

      {
        path: 'Invoicemanger',
        component: () => import('@/views/finance/Invoicemanger'),
        name: 'Invoicemanger',
        meta: { title: 'Invoicemanger' },
      },
      {
        path: 'Invoicemanger/requestInvoice',
        component: () => import('@/views/finance/requestInvoice'),
        name: 'requestInvoice',
        hidden: true,
        meta: {
          title: 'requestInvoice',
          activeNames: ['reconciliationInvoices']
        },
      },
      {
        path: 'Invoicemanger/administer',
        component: () => import('@/views/finance/administer'),
        name: 'administer',
        hidden: true,
        meta: {
          title: 'administer',
          activeNames: ['Invoicemanger']
        },
      },
      {
        path: 'Invoicemanger/Invoicemangerdetail',
        component: () => import('@/views/finance/Invoicemangerdetail'),
        name: 'Invoicemangerdetail',
        hidden: true,
        meta: {
          title: 'Invoicemangerdetail',
          activeNames: ['reconciliationInvoices']
        },
      },
      {
        path: 'Invoicemanger/Invoicemangerjilu',
        component: () => import('@/views/finance/Invoicemangerjilu'),
        name: 'Invoicemangerjilu',
        hidden: true,
        meta: {
          title: 'Invoicemangerjilu',
          activeNames: ['reconciliationInvoices']
        },
      },
      {
        path: 'Invoicemanger/Invoicemangerjiludetail',
        component: () => import('@/views/finance/Invoicemangerjiludetail'),
        name: 'Invoicemangerjiludetail',
        hidden: true,
        meta: {
          title: 'Invoicemangerjiludetail',
          activeNames: ['reconciliationInvoices']
        },
      },
      {
        path: 'Invoicemangerg',
        component: () => import('@/views/finance/Invoicemanger'),
        name: 'Invoicemangerg',
        meta: { title: 'Invoicemangerg' },
      },
      {
        path: 'messageGai',
        component: () => import('@/views/finance/messageGai'),
        name: 'messageGai',
        meta: { title: 'messageGai' }
      },
      {
        path: 'messageManage',
        component: () => import('@/views/finance/messageManage'),
        name: 'messageManage',
        meta: { title: 'messageManage' },
        children: [{
          path: 'sqmsg',
          component: () => import('@/views/finance/sqmsg'),
          name: 'sqmsg',
          meta: { title: 'sqmsg' }
        }]
      },
      {
        path: 'messagePei',
        component: () => import('@/views/finance/messagePei'),
        name: 'messagePei',
        meta: { title: 'messagePei' }
      },
      {
        path: ':route/detail/:sn',
        component: () => import('@/views/finance/detail'),
        name: 'detail',
        hidden: true,
        meta: {
          title: 'detail',
          activeNames: ['financeDetailed']
        }
      },
      {
        path: ':route/orderDetail/:sn',
        component: () => import('@/views/order/orderList/orderDetail'),
        name: 'orderFinanceDetail',
        hidden: true,
        meta: {
          title: 'orderFinanceDetail',
          activeNames: ['siteFinance', 'dealDetailed', 'detailed'],
        }
      },
      {
        path: 'lookInvoicereview/:id?',
        component: () => import('@/views/finance/lookInvoicereview'),
        name: 'lookInvoicereview',
        hidden: true,
        meta: {
          title: 'lookInvoicereview',
          activeNames: ['Invoicereview']
        }
      },

    ]
  },
  // 统计
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/generality-overview',
    name: 'statistics',
    meta: {
      title: 'statistics',
      icon: 'data'
    },
    children: [
      {
        path: 'shop-flow',
        component: () => import('@/views/statistics/analysis/shopFlow'),
        name: 'shopFlow',
        meta: { title: 'shopFlow' }
      },
      {
        path: 'shop-user',
        component: () => import('@/views/statistics/analysis/shopUser'),
        name: 'shopUser',
        meta: { title: 'shopUser' }
      },
      {
        path: 'shop-active',
        component: () => import('@/views/statistics/analysis/shopActive'),
        name: 'shopActive',
        meta: { title: 'shopActive' }
      },
      {
        path: 'shop-data-today',
        component: () => import('@/views/statistics/analysis/shopDataToday'),
        name: 'shopDataToday',
        meta: { title: 'shopDataToday' }
      },
      {
        path: 'shop-data-daily',
        component: () => import('@/views/statistics/analysis/shopDataDaily'),
        name: 'shopDataDaily',
        meta: { title: 'shopDataDaily' }
      },
      {
        path: 'data-today',
        component: () => import('@/views/statistics/analysis/dataToday'),
        name: 'dataToday',
        meta: { title: 'dataToday' }
      },
      {
        path: 'deal-revenue',
        component: () => import('@/views/statistics/analysis/dealRevenue'),
        name: 'dealRevenue',
        meta: { title: 'dealRevenue' }
      },
      {
        path: 'revenue',
        component: () => import('@/views/statistics/analysis/revenue'),
        name: 'revenue',
        meta: { title: 'revenue' }
      },
      {
        path: 'order',
        component: () => import('@/views/statistics/analysis/order'),
        name: 'orderStatistics',
        meta: { title: 'orderStatistics' }
      },
      {
        path: 'goods',
        component: () => import('@/views/statistics/analysis/goods'),
        name: 'goodsStatistics',
        meta: { title: 'goodsStatistics' }
      }
    ]
  },
  // 商城管理
  {
    path: '/application',
    component: Layout,
    redirect: '/application/shop-management',
    name: 'application',
    meta: {
      title: 'application',
      icon: 'app'
    },
    children: [
      {
        path: 'shop-management',
        component: () => import('@/pages/application/shop-management/enterprise/shop-list'),
        name: 'shopManagement',
        hidden: true,
        force: true,
        meta: { title: 'shopManagement' }
      },
      {
        path: 'mallManagementEdit',
        component: () => import('@/views/application/mallManagementEdit'),
        name: 'mallManagementEdit',
        hidden: true,
        meta: { title: 'mallManagementEdit' }
      },
      {
        path: 'combo-card-shop-edit',
        component: () => import('@/views/application/combo-card-shop-edit.vue'),
        name: 'comboCardShopEdit',
        hidden: true,
        meta: { title: 'comboCardShopEdit' }
      },
      // 充值卡
      {
        path: 'czkadd',
        component: () => import('@/views/application/czkMeal/czkMealAdd'),
        name: 'czkMealAdd',
        hidden: true,
        meta: { title: 'czkMealAdd' }
      },
      {
        path: 'czklist',
        component: () => import('@/views/application/czklist'),
        name: 'czkMealList',
        hidden: true,
        meta: { title: 'czkMealList' }
      },
      {
        path: 'exchangeCode1',
        component: () => import('@/views/application/dhm'),
        name: 'exchangeCodelist1',
        hidden: true,
        meta: { title: 'exchangeCodelist1' }
      },
      {
        path: 'add',
        component: () => import('@/views/application/setMeal/setMealAdd'),
        name: 'setMealAdd',
        meta: { title: 'setMealAdd' },
        hidden: true
      },
      {
        path: 'grant',
        component: () => import('@/views/application/grant'),
        name: 'grant',
        meta: { title: 'grant' },
        hidden: true
      },
      {
        path: 'my-grant',
        component: () => import('@/views/application/myGrant'),
        name: 'myGrant',
        meta: { title: 'myGrant' },
        hidden: true
      },
      {
        path: 'grant-use',
        component: () => import('@/views/application/grantUse'),
        name: 'grantUse',
        meta: { title: 'grantUse' },
        hidden: true
      },
      {
        path: 'grant-detail/:id?',
        component: () => import('@/views/application/grantDetail'),
        name: 'grantDetail',
        meta: { title: 'grantDetail' },
        hidden: true
      },
      {
        path: 'grant-details/:id?',
        component: () => import('@/views/application/grantDetails'),
        name: 'grantDetails',
        meta: { title: 'grantDetails' },
        hidden: true
      }
    ]
  },
  // 设置
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/person',
    name: 'setting',
    meta: {
      title: 'setting',
      icon: 'settings'
    },
    children: [
      {
        path: 'safeSetting',
        component: () => import('@/views/setting/safeSetting'),
        name: 'safeSetting',
        meta: { title: 'safeSetting' }
      },
      {
        path: 'shop-transportg',
        component: () => import('@/views/setting/transportg'),
        name: 'transportg',
        meta: { title: 'transportg' }
      },
      {
        path: 'shop-mesg',
        component: () => import('@/views/setting/shopMesg'),
        name: 'shopMesg',
        meta: { title: 'shopMesg' }
      },
      {
        path: 'shop-person',
        component: () => import('@/views/setting/person'),
        name: 'shopPerson',
        meta: { title: 'shopPerson' }
      },
      {
        path: 'shop-identify',
        component: () => import('@/views/setting/identify'),
        name: 'shopIdentify',
        meta: { title: 'shopIdentify' }
      },
      {
        path: 'qualificationCertification', // 资质认证
        component: () => import('@/views/setting/qualificationCertification'),
        name: 'qualificationCertification',
        meta: { title: 'qualificationCertification' }
      },
      {
        path: 'addressManagement', // 收货地址
        component: () => import('@/views/setting/addressManagement'),
        name: 'shippingAddress',
        meta: { title: 'addressManagement' }
      },
      {
        path: 'shop-address',
        component: () => import('@/views/setting/address'),
        name: 'shopAddress',
        meta: { title: 'shopAddress' }
      },
      {
        path: 'shop-addressa',
        component: () => import('@/views/setting/address'),
        name: 'shopAddressa',
        meta: { title: 'shopAddressa' }
      },
      {
        path: 'shop-payment',
        component: () => import('@/views/setting/payment'),
        name: 'shopPayment',
        meta: { title: 'shopPayment' }
      },
      {
        path: 'shop-setting',
        component: () => import('@/views/setting/shopSettings'),
        name: 'shopSettings',
        meta: { title: 'shopSettings' }
      },
      {
        path: 'goods-warning',
        component: () => import('@/views/setting/goodsWarning'),
        name: 'goodsWarning',
        meta: { title: 'goodsWarning' }
      },
      {
        path: 'grade-application',
        component: () => import('@/views/setting/gradeApplication'),
        name: 'gradeApplication',
        meta: { title: 'gradeApplication' },
        hidden: true
      },
      {
        path: 'shop-companyList',
        component: () => import('@/views/setting/companyList'),
        name: 'shopCompanyList',
        meta: { title: 'shopCompanyList' }
      },
      {
        path: 'shop-companyLista',
        component: () => import('@/views/setting/companyList'),
        name: 'shopCompanyLista',
        meta: { title: 'shopCompanyLista' }
      },
      {
        path: "auth-info-site",
        component: () => import("@/views/setting/auth-info/auth-info-site.vue"),
        name: "authenticationInformation",
        meta: { title: "AuthInfoSite" },
      },
    ]
  },

  // 店员管理
  {
    path: '/shop-auth',
    component: Layout,
    redirect: '/shop-auth/shop-assistant',
    name: 'shopAuth',
    meta: {
      title: 'shopAuth',
      icon: 'clerk'
    },
    children: [
      {
        path: 'shop-assistant',
        component: () => import('@/views/shop-auth/shopAssistant'),
        name: 'shopAssistant',
        meta: { title: 'shopAssistant' }
      },
      {
        path: 'role-manage',
        component: () => import('@/views/shop-auth/roleManage'),
        name: 'roleManage',
        meta: { title: 'roleManage' }
      },
      {
        path: 'role-permission/:id(\\d+)',
        component: () => import('@/views/shop-auth/rolePermission'),
        name: 'rolePermission',
        hidden: true,
        meta: {
          title: 'rolePermission',
          noCache: true,
          activeNames: ['roleManage']
        }
      }
    ]
  },

  // 权限
  {
    path: '/shop-auth',
    component: Layout,
    redirect: '/shop-auth/shop-assistantq',
    name: 'shopAuthq',
    meta: {
      title: 'shopAuthq',
      icon: 'jurisdiction'
    },
    children: [
      {
        path: 'shop-assistantq',
        component: () => import('@/views/shop-auth/shopAssistantq'),
        name: 'shopAssistantq',
        meta: { title: 'shopAssistantq' }
      },
      {
        path: 'role-manage',
        component: () => import('@/views/shop-auth/roleManage'),
        name: 'roleManage',
        meta: { title: 'roleManage' }
      },
      {
        path: 'role-permission/:id(\\d+)',
        component: () => import('@/views/shop-auth/rolePermission'),
        name: 'rolePermission',
        hidden: true,
        meta: {
          title: 'rolePermission',
          noCache: true,
          activeNames: ['roleManage']
        }
      }
    ]

  },

  // 通知
  {
    path: '/info',
    component: Layout,
    redirect: '/info/infoList',
    name: 'info',
    meta: {
      title: 'info',
      icon: 'notify'
    },
    children: [
      {
        path: 'infoList',
        component: () => import('@/views/info/infoList'),
        name: 'infoList',
        meta: { title: 'infoList' }
      },
      {
        path: 'enterpriseNotice',
        component: () => import('@/views/info/enterpriseNotice'),
        name: 'enterpriseNotice',
        meta: { title: 'enterpriseNotice' }
      }
    ]
  },
  // ...comboCardShopRouterMap,
  {
    path: '*',
    hidden: true,
    redirect: '/404',
  },
]

// export const comboCardShopRouterMapTemp = [...comboCardShopRouterMap];

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});
